<template>
  <header>
    <div class="mainTop">
         <h1>
            <span @click="reload()" class="mainlogo"><main-logo/></span>
        </h1>
        <div class="search_box">
            <search-box/>
        </div>
        <!-- <banner-ad :rect_width="300" :rect_height="120" filename='banner01.gif'/> -->
        <banner-slide slide_width="300px" slide_height="120px" banner_pos="banner1" :slide_delay="20000" />
    </div>
  </header>
</template>

<script>
//import BannerAd from '@/components/site/BannerAD';
import BannerSlide from '@/components/banner/BannerSlide';
import SearchBox from '@/components/ui/SearchBox';
export default {
  data()
  {
    return{
      bannerData:['banner01.JPG','banner02.JPG','banner03.JPG']
    }
  },
  components:{
    SearchBox,
    //BannerAd,
    BannerSlide
  },
  created(){
    this.fetchBanners();  
  },
  methods:{
    reload(){
        this.$router.push('/home');
        // document.querySelector('.active_menu').classList.remove('active_menu');
        // document.querySelector('.active').classList.remove('active');
        this.$store.commit("menu/setActiveMenu", 'home');
      //window.location.reload();
    },
    async fetchBanners() {
      
      try {
        const response = await this.$store.dispatch("banner/fetchBanners")
          console.log(response);
          
          //console.log("안나오는듯",this.postlists.data.length);
      }catch(error){
          console.log(error.response);
      }
      
    },
  }
}
</script>
<style scoped>
header {
  width: 100%;
  height: 8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background:#fff;
  z-index: 10000;
  position: relative;
}

header a {
  text-decoration: none;
  color: #f391e3;
  display: inline-block;

  border: 1px solid transparent;
}

a:active,
a:hover,
a.router-link-active {
  border: 1px solid #f391e3;
}

h1 {
  margin: 0;

}
.mainlogo{cursor:pointer;}
h1 a {
  color: black;
  margin: 0;
}

h1 a:hover,
h1 a:active,
h1 a.router-link-active {
  border-color: transparent;
}

header .mainTop {
  width:1300px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

header ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

li {
  margin: 0 0.5rem;
}
.search_box{
  flex: 1 auto;

}
.adv_area{
  background:#ccc;
  width:300px;
  height:120px;
  justify-content: center;
  display:flex;
  align-items:center;
}
</style>
